import React from "react";
import "../../../../styles/styles.css";
const Banner = () => {
  return (
    <div className="image-header-business">
      <div className="header-text">
        <div>
          <span style={{width:1000}}>
            Trusted Loading for Business Logistics: <span>Fast</span>
          </span>
        </div>
        <div className="button-container">
          <div className="investor">
            <span>on ZOWO</span>
            <span>Fair, and Only</span>
          </div>
          <button className="signup-zowo">Signup with Zowo</button>
        </div>
      </div>
    </div>
  );
};
export default Banner;
